import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import getSupportedLocations from '../services/locations/getSupportedLocations';
import createSupportedLocation from '../services/locations/createSupportedLocation';

// THUNKS
export const fetchSupportedLocations = createAsyncThunk(
  'locations/getSupportedLocations',
  getSupportedLocations.handler
);

export const addSupportedLocation = createAsyncThunk(
  'locations/createSupportedLocation',
  createSupportedLocation.handler
);

const initial_state = {
  lists: [],           // currently displayed locations (may be filtered by state)
  filtered_state: '',  // which state is currently being filtered ('' = all)
  loading: false,
  initialized: false,  // true once the first fetch completes — prevents re-fetching
  creating: false,  // true while POST is in-flight

};

// slice definition
const slice = createSlice({
  name: 'locations',
  initialState: initial_state,
  reducers: {
    /**
     * 
     * WHY: Once we've fetched all locations from the Lambda, switching the
     * state filter should NOT trigger another API call. We just slice the
     * in-memory array. This makes filter switching instant (0ms, no network).
     * 
     * If state is '' (empty), shows everything.
     */
    clearLocations: (state) => {
      state.allLocations = [];
      state.lists = [];
      state.filtered_state = '';
      state.initialized = false;
    }
  },
  extraReducers: builder => {
    builder

      // querySupportedLocations
      .addCase(fetchSupportedLocations.pending, getSupportedLocations.pending)
      .addCase(fetchSupportedLocations.fulfilled, getSupportedLocations.fulfilled)
      .addCase(fetchSupportedLocations.rejected, getSupportedLocations.rejected)

      // createSupportedLocation
      .addCase(addSupportedLocation.pending, createSupportedLocation.pending)
      .addCase(addSupportedLocation.fulfilled, createSupportedLocation.fulfilled)
      .addCase(addSupportedLocation.rejected, createSupportedLocation.rejected);
  },
});

export const { clearLocations } = slice.actions;
const { reducer } = slice;
export default reducer;